import React from 'react';

interface PetAvatarProps {
  /** Server-resized (~96px) photo URL; when null the `fallback` is shown instead. */
  photoThumbUrl: string | null;
  /** Rendered when there's no photo (e.g. a species emoji or a paw glyph). */
  fallback: React.ReactNode;
  /** Class for the round container — supplied by the caller's SCSS module so each
   *  table keeps its own sizing. */
  className: string;
  /** Class for the `<img>` (object-fit cover, full size). */
  imgClassName: string;
}

/**
 * A pet's round thumbnail: a lazy-loaded photo, or a caller-supplied fallback
 * glyph when there's none. The single place the photo-vs-fallback decision lives,
 * shared by the pets/device tables (via PetNameCell) and the Dashboard PetsTable.
 * Styling is injected via className so each consumer keeps its own dimensions.
 */
export default function PetAvatar({ photoThumbUrl, fallback, className, imgClassName }: PetAvatarProps) {
  return (
    <span className={className}>
      {photoThumbUrl ? <img src={photoThumbUrl} alt="" loading="lazy" className={imgClassName} /> : fallback}
    </span>
  );
}
